export const stepOneData = [
  {
    paraOne:
      "If you're carrying debt on  a personal loan with high interest rates, you're likely paying a significant amount in interest each year. By transferring this debt to a balance transfer option with a lower rate, you can save on interest and pay off your debt faster. Use Minemi's balance transfer calculator to see how much you could save by transferring your debt.",
    paraTow: "Why Choose MinEMI for Your Balance Transfer Needs?",
    paraThree:
      "Are you paying a high EMI on your personal loan? MinEMI’s Personal Loan Balance Transfer feature is designed to help you save. Transfer your loan to a lender offering lower interest rates, reduced EMIs, or better terms and unlock significant financial savings. Let MinEMI guide you through a smooth, hassle-free process, ensuring you make the most of your money.",
  },
  {
    heading: "When to Use MinEMI’s Personal Loan Balance Transfer?",
    subheading:
      "Knowing the right time to transfer your personal loan can amplify your savings. Here are the ideal situations to opt for a balance transfer with MinEMI:",
    personal_lone: [
      {
        heading: "After Repo Rate Reductions:",
        description:
          "A repo rate cut often results in reduced loan interest rates by lenders. If your current loan doesn’t reflect this change, it’s time to explore better options through MinEMI.",
      },
      {
        heading: " When Your Financial Stability Improves:",
        description:
          "Got a new job, a promotion, or more stable income? Lenders may offer you better terms. Use this opportunity to transfer your loan and enjoy the benefits.",
      },
      {
        heading: " Mid-Tenure of Your Loan:",
        description:
          "Maximum savings happen when you transfer your loan early or mid-tenure. MinEMI calculates this for you and ensures you make a well-informed decision.",
      },
      {
        heading: "After a Credit Score Boost:",
        description:
          "A higher credit score means better interest rates. If you’ve improved your score, let MinEMI help you find lenders that reward your efforts with lower EMIs.",
      },
      {
        heading: " Market Interest Rate Drops:",
        description:
          "Even a small reduction in interest rates can lead to substantial savings. MinEMI keeps you updated on the latest offers, ensuring you switch to the best possible terms.",
      },
    ],
  },
];

export const savingCalculator = [
  {
    id: 1,
    title: "Personal Loan Balance Transfer Calculator",
    description:
      "Transferring debt to a credit card or loan with a lower interest rate can save you money on interest while you pay off your debt.",
  },
  {
    id: 2,
    inputsHeadingOne: "Your Current Loan",
    inputsHeadingTwo: "Details of New Loan",
  },
];

export const helpData = [
  {
    id: 1,
    needhelp: "Need help with this information? Click here",
    title: "Where to find information for the calculator",
    information: [
      {
        id: 1,

        subtitle: "Existing debt: Credit card debt to transfer",
        infotext:
          "Your monthly credit card statement will show you how much you currently owe. You can also find it by logging into your account online. Make sure to enter the card's balance, rather than the current minimum payment (which is often the more prominent number on your statement).",
      },
      {
        id: 2,
        subtitle: "Existing debt: Interest rate",
        infotext:
          'The interest rate, or APR, that applies to your account also appears on your monthly credit card statement. Look for a section labeled "Interest charges" or "Interest charge calculation." The rate charged on purchases made with the card is the "purchase APR."',
      },
      {
        id: 3,
        subtitle: "Balance transfer card: Transfer fee",
        infotext:
          'With only a few exceptions, every card will charge you a fee for transferring a balance to it. You can find the balance transfer fee for any credit card in the Schumer box, a table of rates and fees that card issuers are required to make available to people applying for the card. On the web, the marketing page for a credit card will typically have a link to the Schumer box, labeled something like "See rates and fees" or "See terms." Balance transfer fees are typically a percentage of the amount transferred, and there\'s usually a minimum fee. For example, the fee might be described as "3% of the amount transferred, or $10, whichever is greater." For simplicity, our balance transfer calculator uses just the percentage fee; unless you\'re transferring only a few hundred dollars in debt, you\'ll be paying more than that minimum dollar amount.',
      },
      {
        id: 4,
        subtitle: "Balance transfer card: 0% intro APR period",
        infotext:
          'The number of months in the 0% introductory period will also be listed in the Schumer box. Look for a section labeled "Annual percentage rate (or APR) for balance transfers." It will tell you how many billing periods you get at 0% before the APR on transferred balances resets to the regular rate. If a portion of the balance is still unpaid at the end of the intro period, you\'ll be charged that rate going forward.',
      },
    ],
  },
];
